import { Injectable } from '@angular/core';
import { FormControlTypeEnum } from '../models/form-control-type.enum';
import { AppVariables, ColumnModel } from '@shared';
import { ColumnStyleTypeEnum } from '../models/column-style-type.enum';
import { ColumnDataTypes } from '@database/models';
import { EditStyleModel } from '../models';

@Injectable()
export class FormControlTypeProviderService {
	public getFormControlType(columnModel: Partial<ColumnModel>): FormControlTypeEnum {
		console.log("Test 123445: ", columnModel);
		switch (columnModel.column_style) {
			// todo: this is not the final code. This will be changed while implementing each control
			case ColumnStyleTypeEnum.textbox: {
				if (columnModel.calculation_formula) {
					return FormControlTypeEnum.Formula;
				}

				switch (columnModel.data_type) {
					case ColumnDataTypes.IMAGE: {
						if (columnModel.edit_style.toLowerCase() === EditStyleModel.signature) {
							return FormControlTypeEnum.Signature;
						}
						// Image support is not included in the scope, only signature
						break;
					}

					case ColumnDataTypes.CHAR: {
						if (columnModel.edit_style === EditStyleModel.checkbox) {
							return FormControlTypeEnum.CheckBox;
						}

						const fieldWidth = columnModel.width ?? AppVariables.DEFAULT_FIELD_WIDTH;
						if (fieldWidth > AppVariables.LONG_TEXT_LIMIT) {
							return FormControlTypeEnum.Textarea;
						}

						return FormControlTypeEnum.Textbox;
					}
					case ColumnDataTypes.NUMERIC:
						return ['GPSX', 'GPSY', 'GPSZ', 'GPS'].includes(columnModel.edit_style)
							? FormControlTypeEnum.Gps
							: FormControlTypeEnum.Numeric;
					case ColumnDataTypes.DATETIME: {
						if (
							columnModel.edit_style &&
							(columnModel.edit_style.toLowerCase() === EditStyleModel.time24 ||
								columnModel.edit_style.toLowerCase() === EditStyleModel.timeAmPm)
						) {
							return FormControlTypeEnum.TimePicker;
						}

						return FormControlTypeEnum.DatePicker;
					}
					case ColumnDataTypes.DATE:
						return FormControlTypeEnum.DatePicker;
				}
				break;
			}

			case ColumnStyleTypeEnum.editableDropdown:
				return FormControlTypeEnum.Dropdown;
			case ColumnStyleTypeEnum.nonEditableDropdown:
				return FormControlTypeEnum.Dropdown;
			// todo: just return text box until we handle all types
			default:
				return FormControlTypeEnum.Textbox;
		}
	}
}
